// extracted by mini-css-extract-plugin
module.exports = {"container":"_3lPhO1AnJHZ9SIollTD5ax","visible":"_1WiET_tdqsVB-KcPu3Xb52","cancelBtn":"_1pb0NZK11jHENsuS4XNaO8","icon":"_24xZ2Z5CbSRN3Rv4uA0DYx","saveBtn":"_2GeuGqlUE38NMSTKe57dEe"};